export enum RedirectionType {
    internal = 0,
    external = 1
}

